import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

import UploadImageIcon from '@components/basics/icons/upload-image';

interface NoAvatarProps {
  className?: string;
}

const NoAvatar: FunctionComponent<NoAvatarProps> = ({ className }) => {
  return (
    <div className={className || ''}>
      <UploadImageIcon className="icon" />
    </div>
  );
};

export default styled(NoAvatar)`
  border: 1px dashed ${({ theme }) => theme.colors.border};
  border-radius: 2px;
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    width: 28px;
  }
`;
